import * as React from 'react';
import { PageContainer, PageContent, PageWrap } from './page.styles';
import { TabNavigation } from '../components/blocks/tabs/tabNavigation';
import { Header } from '../components/blocks/header/header';

interface Props {
  title: string;
  tabNavigation: boolean;
}

export class Page extends React.Component<Props, {}> {
  public componentDidMount() {
    document.title = this.props.title;
  }

  public render() {
    return (
      <PageContainer>
        <PageWrap>
          <Header userName={'Veranda Baker'} />
          <PageContent>
            {this.props.children}
          </PageContent>
        </PageWrap>
        {this.renderMenu()}
      </PageContainer>
    );
  }

  public renderMenu(): JSX.Element {
    if (!this.props.tabNavigation) {
      return null;
    }

    return (
      <TabNavigation
        tabs={[
          {
            iconURL: require('../../assets/icons/user.svg'),
            href: '/'
          },
          {
            iconURL: require('../../assets/icons/envelope.svg'),
            href: '/'
          },
          {
            iconURL: require('../../assets/icons/cog.svg'),
            href: '/maintenance'
          }
        ]}
      />
    );
  }
}
